// extracted by mini-css-extract-plugin
export var layoutContainer = "_75-0";
export var layoutContainerNoRounding = "_75-6";
export var layoutContainerOpen = "_75-5";
export var layoutContainerResizing = "_75-1";
export var mainContent = "_75-2";
export var resizeDivider = "_75-3";
export var slidePanel = "_75-4";